import React from "react";
import { connect } from "react-redux";
import { DatePicker, Space } from 'antd';
import { getDraftEditLogs } from "../../../actions/index";


import loader from '../../../assets/images/loader.gif'
import 'antd/dist/antd.css';
import './draftEditSearch.css';
import history from "../../../history";



const { RangePicker } = DatePicker;


export class DraftEditSearch extends React.Component {

    constructor(props) {
        super(props);
        this.searchBox = React.createRef();
        this.searchButton = React.createRef();
        this.logsLimitInput = React.createRef();
        this.state = {
            showError: false,
            errorMessage: "",
            dateMoment: [],
            dateString: [],
            logsLimit: "200"
        }

    }

    componentDidMount() {
        if ((this.props.logTerm && this.props.logType === 'drafts') && !(this.props.logs && this.props.logs.length) ) {
            this.searchBox.current.value = this.props.logTerm
            this.getInfo()
        }
    }
    handleKeyPressOnInput = (e) => {

        if (e.key === 'Enter') {
            this.getInfo()
        }
    }

    getInfo = () => {
            
        
        this.searchButton.current.disabled = true
        this.searchButton.current.innerHTML = `<img src=${loader} alt='loader' width="30%" />`

        let searchTerm = this.searchBox.current.value ? this.searchBox.current.value.trim() : this.props.searchTerm ? this.props.searchTerm.trim() : ''

        if (searchTerm.toLowerCase()
            .match(/^[0-9]+$/) !== null
        ) {

            history.push(`/log/drafts/${searchTerm}`)
            this.props.getDraftEditLogs(searchTerm, this.state.dateString, this.state.logsLimit)
                .then((response) => {
                    this.searchButton.current.disabled = false
                    this.searchButton.current.innerHTML = "Get Info"

                    if (response === 'success') {

                        if (!this.props.logs) {
                            console.log('No Results found')
                            this.setState({ errorMessage: 'No Results Found!', showError: true })
                        } else {
                            console.log('DraftEdits Log Search Results')
                            this.setState({ errorMessage: '', showError: false })
                            console.log(this.props.logs.length)
                            console.log(this.props.logs[0])
                        }
                    } else {
                        console.log('An error occurred while performing this operation')
                        this.setState({ errorMessage: 'An error occurred while performing this operation', showError: true })
                    }
                })

        } else {
            this.searchButton.current.disabled = false
            this.searchButton.current.innerHTML = "Get Info"
            this.setState({ errorMessage: 'Enter a valid Campaign ID', showError: 'true' })

        }

    }



    render() {
        return (
            <React.Fragment>
                <div className="DraftEditSearch-box">
                    <div className="DraftEditSearch-input">
                        <input type='text' id="DraftEditSearch" placeholder="Enter Campaign ID" onKeyDown={this.handleKeyPressOnInput} ref={this.searchBox} defaultValue={this.props.searchTerm ? this.props.searchTerm : this.props.search ? this.props.search : ''}></input>
                        <div className={`DraftEditSearch-Error ${this.state.showError ? 'show' : 'hidden'}`} >{this.state.errorMessage}</div>
                    </div>
                    <button id="campaignButton" ref={this.searchButton} onClick={this.getInfo}> Get Info</button>
                    <div className="DraftEditSearch-date">
                        <Space direction="horizontal" size={11}>
                            <RangePicker onChange={(dateMoment, dateString) => {
                                if (dateString.length && dateString[0].length) {

                                    this.setState({
                                        dateMoment, dateString: [dateString[0], //Moving endDate by 1 day
                                        new Date(Date.parse(dateString[1]) + 86400000).toISOString().substring(0, 10)]
                                    })
                                } else {
                                    this.setState({
                                        dateMoment: [],
                                        dateString: []
                                    })
                                }
                            }}
                                value={this.state.dateMoment ? this.state.dateMoment : []} />
                        </Space>
                    </div>
                </div>
                <div className="DraftEditSearch-filters">
                    <div className="DraftEditSearch-filters-heading">Filters</div>
                    <div className="DraftEditSearch-filters-search">
                        <h4>Search Last</h4>
                        <select name="logsLimit" id="logsLimit" ref={this.logsLimitInput} value={this.state.logsLimit ? this.state.logsLimit : '200'}
                            onChange={(e) => { this.setState({ logsLimit: e.target.value }) }}
                        >
                            <option value="200">200 Logs</option>
                            <option value="500">500 Logs</option>
                            <option value="1000">1000 Logs</option>
                        </select>
                    </div>

                </div>


            </React.Fragment>
        );
    }
}


const mapStateToProps = (state) => {
    return {
        logs: state.logs.draftEditLogs.logs, searchTerm: state.logs.draftEditLogs.searchTerm
    };
};

export default connect(mapStateToProps, { getDraftEditLogs })(DraftEditSearch);
